/* eslint-disable @typescript-eslint/no-explicit-any */
// Styles for __name__ go here.
import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';
import { HINDI_LANG } from '../../modules/constants';

export const StyledSearchForm = styled.div<{
  $isNextGenHP?: boolean;
  $hideDestination?: boolean;
}>`
  .adv-search-brands-dropdown .dropdown-to-modal {
    padding-left: 0 !important;
    padding-right: 0;
    .m-dropdown-header {
      padding-left: ${toRem(24)};
      padding-right: ${toRem(24)};
    }
    .m-dropdown-action-bar {
      padding-left: ${toRem(24)} !important;
      padding-right: ${toRem(24)} !important;
    }
    .m-dropdown-children {
      padding-left: ${toRem(24)};
      padding-right: ${toRem(24)};
    }
  }
  .brand-filter__category_label_title {
    padding-right: ${toRem(16)} !important;
    @media ${baseVariables.mediaQuery.md} {
      padding-right: ${toRem(12)} !important;
    }
  }
  .brand-filter__category_label_btn :after {
    content: '';
    display: block;
    margin: 0 auto;
    width: 100%;
  }
  .brand-filter__category_label_btn {
    padding-left: ${toRem(16)} !important;
    font: ${baseVariables.font.fontWeightMedium};
    @media ${baseVariables.mediaQuery.md} {
      padding-left: ${toRem(12)} !important;
      font: ${baseVariables.font.fontWeightMedium};
    }
  }
  .search-form-edit-button {
    .nowrap {
      white-space: nowrap;
    }
    .edit-cta-content {
      width: max-content;
    }
  }
  .custom-basis {
    min-width: ${toRem(290)};
    flex-basis: 1;
    @media ${baseVariables.mediaQuery.lg} {
      flex-basis: ${toRem(290)};
    }
  }
  .use-points-wrapper {
    display: flex;
    align-items: center;
    gap: ${toRem(8)};
  }

  .points-awards-css {
    color: ${baseVariables.color.neutral40};
  }

  .secondary-level-button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    @media ${baseVariables.mediaQuery.lg} {
      padding-right: 0;
    }
  }
  .hide_secondary_form {
    display: none !important;
  }

  .icon-arrow-down:before {
    height: ${toRem(16)};
  }
  .icon-arrow-up:before {
    height: ${toRem(16)};
  }
  .header-heading {
    margin-bottom: 0;
  }
  .icon-dropdown-down:before,
  .icon-dropdown-up:before {
    line-height: ${toRem(16)};
    font-size: ${toRem(16)};
  }
  .enable-conversational-ai-search {
    padding: ${toRem(8)} !important;
    z-index: 49;
    border-radius: ${toRem(32)} ${toRem(32)} ${toRem(16)} ${toRem(16)} !important;
  }
  .search-form-wrapper {
    @media ${baseVariables.mediaQuery.desktop} {
      /* NextGen: No box-shadow or border-radius (full bleed design)
         NextGenHP: Original styling */
      ${props =>
        props.$isNextGenHP
          ? `
        box-shadow: 0px ${toRem(4)} ${toRem(20)} 0px rgba(0, 0, 0, 0.07);
        border-radius: ${toRem(16)};
      `
          : `
        box-shadow: none;
        border-radius: 0;
      `}
    }
    label {
      margin-bottom: 0;
    }
  }

  .cancel-cta-btn {
    width: auto;
    height: var(--General-spacer-05, ${toRem(32)});
    gap: var(--General-spacer-01, ${toRem(4)});
    font-size: ${toRem(13)}; //not using font size from baseVariables because it is not defined
    line-height: ${toRem(13)}; //not using line height from baseVariables because it is not defined
  }
  .update-cta-hp {
    height: ${toRem(40)};
    width: 100%;
    min-width: ${toRem(100)};
    gap: var(--General-spacer-01, ${toRem(4)});
    border-radius: var(--t-button-border-radius, ${toRem(52)});
    flex-shrink: 0;
    align-self: stretch;
    font-size: ${baseVariables.font.fontM};
    line-height: ${baseVariables.font.lineHeightXs};
    font-weight: ${baseVariables.font.fontWeightMedium};
    @media ${baseVariables.mediaQuery.lg} {
      min-width: ${toRem(120)};
      height: ${toRem(52)};
      flex: 1 0 0;
      font-size: ${baseVariables.font.fontL};
      line-height: ${baseVariables.font.lineHeightS};
    }
  }
  .update-cta {
    height: ${toRem(40)};
    width: 100%;
    gap: var(--General-spacer-01, ${toRem(4)});
    font-size: ${baseVariables.font.fontM};
    line-height: ${baseVariables.font.lineHeightXs};
    @media ${baseVariables.mediaQuery.lg} {
      height: ${toRem(32)};
      font-size: ${toRem(13)}; //not using font size from baseVariables because it is not defined
      line-height: ${toRem(13)}; //not using line height from baseVariables because it is not defined
    }
  }
  @media (hover: none) and (pointer: coarse) {
    .m-button-primary-icon.update-cta,
    .m-button-primary-icon.update-cta-hp {
      -webkit-tap-highlight-color: transparent;
    }

    .m-button-primary-icon.update-cta:hover,
    .m-button-primary-icon.update-cta-hp:hover,
    .m-button-primary-icon.update-cta.is-hover,
    .m-button-primary-icon.update-cta-hp.is-hover {
      box-shadow: inset ${toRem(9999)} ${toRem(9999)} var(--t-button-primary-bg-color);
      color: var(--t-button-primary-fg-color);
      border-color: var(--t-button-primary-border-color);
    }
  }
  .edit-cta-btn {
    width: 100%;
    font-size: ${baseVariables.font.fontS};
    line-height: ${toRem(21)}; //not using line height from baseVariables because it is not defined
    gap: ${toRem(8)};
    margin-left: 0;
  }
  .cta-group {
    gap: ${toRem(24)};
  }
  .m-input-text-field {
    label,
    input {
      cursor: pointer;
    }
  }
  .brand-field {
    padding: ${toRem(26)} ${toRem(40)} ${toRem(10)} ${toRem(16)} !important;
    cursor: pointer;
    font-weight: ${baseVariables.font.fontWeightMedium} !important;
    text-overflow: ellipsis;
  }
  .m-input-text-field > label {
    font-size: ${baseVariables.font.fontXs};
    line-height: ${toRem(12)};
  }

  &.sticky-search-container {
    position: fixed;
    width: 100%;
    top: 0 !important;
    left: 0;
    background: ${baseVariables.color.white};
    margin-top: 0 !important;
    z-index: 150;
    padding: 0 ${toRem(16)} !important;
    @media ${baseVariables.mediaQuery.desktop} {
      padding: 0 !important;
    }
    .custom-padding {
      box-shadow: none;
    }
  }
  &.search-container-top {
    padding-top: ${toRem(16)} !important;
    @media ${baseVariables.mediaQuery.desktop} {
      padding-top: ${toRem(32)} !important;
    }
  }

  &.sticky-search-top {
    position: fixed;
    width: 100%;
    left: 0;
    background: ${baseVariables.color.white};
    margin-top: 0 !important;
    z-index: 30;
    transition: top 0.4s ease 0s;
    padding: 0 ${toRem(16)} !important;
    @media ${baseVariables.mediaQuery.desktop} {
      padding: 0 !important;
    }
    .custom-padding {
      box-shadow: none;
    }
  }

  &.search-wrapped {
    ${props => (props.$isNextGenHP ? `padding-top: ${toRem(20)} !important;` : '')}
    @media ${baseVariables.mediaQuery.md} {
      ${props => (props.$isNextGenHP ? `padding-top: ${toRem(32)} !important;` : '')}
    }
    .search-form-wrapper {
      border-radius: ${toRem(8)};
      @media ${baseVariables.mediaQuery.lg} {
        border-radius: ${toRem(16)};
      }
    }
  }

  &.sticky-search-wrapped {
    width: 100%;
    background: ${baseVariables.color.white};
    margin-top: 0 !important;
    padding: ${toRem(14)} ${toRem(16)} !important;
    border-radius: 0;
    @media ${baseVariables.mediaQuery.lg} {
      padding: 0 !important;
    }
    .search-form-wrapper {
      box-shadow: none;
    }
  }

  /* New NGSearchForm sticky styles when controlled by useNGSearchFormScroll hook */
  &.ng-sticky-form {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    background: ${baseVariables.color.white};
    z-index: 150;
    margin-top: 0 !important;
    transition: transform 0.3s ease-in-out;
    box-shadow: 0px ${toRem(2)} ${toRem(8)} 0px rgba(0, 0, 0, 0.1);
    padding: ${toRem(16)} ${toRem(16)} !important;
    @media ${baseVariables.mediaQuery.lg} {
      padding: ${toRem(24)} ${toRem(16)} !important;
    }
    .search-form-wrapper {
      box-shadow: none;
      border-radius: 0;
    }
    /* Prevent flex children from collapsing during sticky transition */
    .primary-wrapper,
    .document_search_form.standard,
    .searchfrom-submit-btn {
      flex-shrink: 0;
    }
  }

  .icon-search {
    font-size: ${toRem(20)};
    ::before {
      height: ${toRem(16)};
      width: ${toRem(16)};
      display: flex;
      justify-content: center;
      align-items: center;
      @media ${baseVariables.mediaQuery.lg} {
        height: ${toRem(32)};
        width: ${toRem(32)};
      }
    }
  }

  .w-100 {
    width: 100%;
  }

  /* NextGen only (not NextGenHP): Override global styles from apps/book/styles/common.scss */
  ${props =>
    !props.$isNextGenHP &&
    `
    @media ${baseVariables.mediaQuery.md} {
      .document_search_form_container .primary-wrapper {
        padding-top: 0 !important;
        padding-right: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 0 !important;
        margin-top: 0 !important;
      }

      .document_search_form_container .search-form-secondary-wrapper {
        padding-top: 0 !important;
        padding-right: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 0 !important;
      }

      .document_search_form_container .availibilty-search-container {
        align-content: center;
      }
    }
  `}
`;

export const StyledSearchFormWrapper = styled.div<{
  topOffset?: string;
  isNonStickyVariant?: boolean;
  $isNextGenHP?: boolean;
}>`
  &.ng-search-form-position {
    position: absolute;
    width: 100%;
    top: ${({ topOffset }) => topOffset};
    left: 0;
  }
  &.m-container-fullbleed {
    background-color: ${baseVariables.color.base20};
  }

  /* Mobile: Add border-top for NextGen (not NextGenHP) */
  ${props =>
    !props.$isNextGenHP
      ? `
    border-top: ${toRem(1)} solid ${baseVariables.color.neutral20};
  `
      : ''}

  @media ${baseVariables.mediaQuery.lg} {
    ${props => (props.isNonStickyVariant ? 'z-index: 48;' : 'z-index: 49;')}

    /* NextGen: Add border and box-shadow above all content (not NextGenHP) */
    ${props =>
      !props.$isNextGenHP
        ? `
      border-top: ${toRem(1)} solid ${baseVariables.color.neutral20};
    `
        : ''}
  }

  /* NextGen (not NextGenHP): consistent vertical padding regardless of state */
  ${props =>
    !props.$isNextGenHP &&
    `
    &:not(.ng-search-form-position) {
      padding-top: ${toRem(16)};
      padding-bottom: ${toRem(16)};
      
      @media ${baseVariables.mediaQuery.md} {
        padding-top: ${toRem(24)};
        padding-bottom: ${toRem(24)};
      }
    }
  `}
`;

export const StyledSearchFormMobileWrapperDiv = styled.div<{
  isNonStickyVariant?: boolean;
  $isNextGenHP?: boolean;
}>`
  &.searchform-box-shadow {
    box-shadow: 0 ${toRem(4)} ${toRem(20)} 0 rgba(0, 0, 0, 0.07);
    border: ${toRem(1)} solid ${baseVariables.color.neutral30};
  }
  display: flex;
  border-radius: ${toRem(8)};
  background: ${baseVariables.color.alert10};
  ${props => (props.isNonStickyVariant ? 'z-index: 48;' : 'z-index: 49;')}
  position: relative;

  /* NextGenHP overrides - must come AFTER base styles */
  ${props =>
    props.$isNextGenHP
      ? `
    height: ${toRem(56)};
    border-radius: ${toRem(56)};
    align-items: center;
    justify-content: center;
  `
      : `
    /* NextGen standard mobile: full bleed layout - only for direct children (outside modal) */
    align-items: center;
    justify-content: space-evenly;
    height: ${toRem(20)};
    
    /* These styles only apply to direct children (outside modal content) */
    /* Override Bootstrap .row flex-wrap for NextGen mobile (outside modal only) */
    > .primary-wrapper > .row,
    > .primary-wrapper > .primary-container,
    > .primary-wrapper > div {
      flex-wrap: nowrap;
      gap: ${toRem(20)};
    }
    
    /* Primary wrapper styling for NextGen mobile inactive state (outside modal) */
    > .primary-wrapper {
      flex: 0 1 auto !important;
      gap: ${toRem(20)};
    }
    
    /* Remove margin-bottom from input fields for NextGen mobile (outside modal only) */
    > .primary-wrapper .m-input-text-field {
      margin-bottom: 0 !important;
    }
    
    /* Secondary wrapper styling for NextGen mobile inactive state (outside modal) */
    > .primary-wrapper + .search-form-secondary-wrapper {
      flex: 0 1 auto;
    }
    
    /* Edit button styling for NextGen mobile */
    .edit-cta-btn {
      padding: 0;
      min-width: auto;
      background: transparent;
      border: none;
      margin-right: ${toRem(16)};
      
      .icon-edit {
        font-size: ${toRem(20)};
      }
    }
    
    /* Reset styles inside modal to match HP form */
    .mobile-search-form {
      .row, .primary-container {
        flex-wrap: wrap !important;
      }
      .m-input-text-field {
        margin-bottom: 1rem !important;
      }
      /* Reset primary-wrapper margins inside modal */
      .primary-wrapper {
        flex: 1 1 40% !important;
        margin-left: 0;
        margin-right: 0;
      }
    }
  `}

  .hotels-form-error-messages {
    .message-link {
      text-decoration: underline;
    }
  }
  .adv-search-brand-field-dropdown {
    overflow-y: hidden !important;
    .m-dropdown-children {
      height: inherit;
      overflow-y: auto !important;
      scroll-margin-bottom: ${toRem(16)};
      padding-bottom: ${toRem(116)};
    }
    .m-dropdown-action-bar {
      border-radius: 0;
    }
  }
  .destination-input-field {
    padding: ${toRem(16)};
    @media only ${baseVariables.mediaQuery.md} {
      justify-content: center;
    }
  }
  .dates-input-field {
    padding: ${toRem(16)};

    // Mobile-first: dates-input-field uses standard form field styles by default
    .m-input-text-field
      input[type='text']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
      // Mobile styles - inherits standard form field appearance
    }

    // Desktop styles for dates-input-field to match NGDatepicker desktop styles
    @media ${baseVariables.mediaQuery.lg} {
      .m-input-text-field
        input[type='text']:not([type='submit']):not([type='button']):not([type='checkbox']):not([type='radio']) {
        border: none;
        padding: 0 0 0 ${toRem(8)};
        width: var(--input-ch-width, auto);
        font-size: ${toRem(16)};
        color: ${baseVariables?.color?.neutral40};
      }
    }
  }
  .dashed-separator {
    border: ${toRem(1)} dashed;
    margin: ${toRem(16)} ${toRem(2)};
  }
  .m-input-text-field-no-border label {
    margin-bottom: ${toRem(4)};
  }
  .hotels-form-error-messages {
    max-width: fit-content;
    margin-left: 0;
    padding: 0 ${toRem(8)};
  }
  .mobile-wrapper-default {
    width: 100%;
  }

  .m-input-text-field-no-border input[type='text'] {
    font-size: ${toRem(18)} !important;
    line-height: ${toRem(20)} !important;
    &:is(${HINDI_LANG}) {
      line-height: ${toRem(24)} !important;
    }
  }

  .mobile-homepage-button {
    z-index: 49;
    color: ${baseVariables.color.neutral40};
    border-color: ${baseVariables.color.neutral30};
    background: ${baseVariables.color.alert10};
    max-height: ${toRem(40)};
    height: ${toRem(40)};
    .t-font-s {
      color: ${baseVariables.color.neutral40};
    }
    &:first-child {
      border-right: ${toRem(1)} dashed ${baseVariables.color['dark-gray-6']};
      padding-right: ${toRem(10)};
      height: ${toRem(40)};
    }
  }

  .mobile-homepage-date-field {
    z-index: 49;
    color: ${baseVariables.color.neutral40};
    border-color: ${baseVariables.color.neutral30};
    background: ${baseVariables.color.alert10};
    max-height: ${toRem(40)};
    height: ${toRem(40)};
    padding-left: ${toRem(20)};
    .t-font-s {
      color: ${baseVariables.color.neutral40};
    }
  }
  .mobile-view-font {
    font-size: ${toRem(18)} !important;
    color: ${baseVariables.color.neutral40} !important;
  }
  .mobile-homepage-button:hover {
    background: ${baseVariables.color.alert10};
    box-shadow: none;
    color: ${baseVariables.color.neutral00};
  }
  .mobile-search-form {
    .m-dropdown-header {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: ${toRem(24)};
      position: sticky;
      top: 0;
      background: ${baseVariables.color['base20']};
      z-index: 1;
      &:after {
        width: 100%;
      }
    }
    .cta-button-group {
      padding-left: ${toRem(16)};
      padding-right: ${toRem(16)};
    }
  }

  .m-input-text-field {
    box-sizing: border-box;
    margin-bottom: ${toRem(16)};
  }

  .cta-button-group {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: ${toRem(16)} ${toRem(24)};
    background: ${baseVariables.color.base20};
    z-index: 1010;
  }

  .dropdown-to-modal {
    border-bottom-left-radius: 0;

    border-bottom-right-radius: 0;
    height: 100% !important;
    max-height: calc(100vh - ${toRem(80)}) !important;
    padding: ${toRem(24)} ${toRem(16)} ${toRem(16)} ${toRem(16)} !important;
    top: ${toRem(80)} !important;
    .m-dropdown-content {
      height: calc(100% - ${toRem(80)}) !important;
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
    .m-dropdown-children {
      height: 100%;
    }
  }
  .search-form-secondary-wrapper:not(.hide-border-bottom) {
    border-bottom: ${toRem(1)} solid ${baseVariables.color.neutral30};
  }
  .adv-brand-filter {
    padding: 0 ${toRem(8)};
    width: 100%;

    @media ${baseVariables.mediaQuery.md} {
      padding: 0 ${toRem(12)};
      width: 50%;
    }
  }
`;

export const StyledSearchFormDesktopWrapperDiv = styled.div<{
  $isNextGenHP?: boolean;
  $hideDestination?: boolean;
  $isBulgariDomain?: boolean;
  $showPointsAsCheckbox?: boolean;
}>`
/* ============================================================
   NEXTGEN DESKTOP FLEX LAYOUT (tablet and desktop only)
   
   Structure:
   - Parent: StyledSearchFormDesktopWrapperDiv (display: flex)
     - Child 1: .primary-wrapper (SearchPrimaryBlock)
       - Child 1a: div > div.standard [SearchField] (destination)
       - Child 1b: div > div.standard [DatePicker] (dates)
     - Child 2: .search-form-secondary-wrapper / .document_search_form.standard (SearchSecondaryBlock)
       - Child 2a: div.standard [RoomsAndGuests]
       - Child 2b: div.standard [SpecialRates]
     - Child 3: .searchfrom-submit-btn (SearchFormCTAGroup)
   
   Scenarios (NextGen only, tablet/desktop):
   - Standard (4 inputs): All inputs equal width (25% each), CTA auto flush right
   - hideDestination/ADF (3 inputs): All inputs equal width (33% each), CTA auto flush right
   - hideDestination + Bulgari (2 inputs): All inputs equal width (50% each), CTA auto flush right
   
   Gap: 16px between all inputs
   ============================================================ */

/* Base flex container */
display: flex;
align-items: center;
justify-content: ${props => (props.$isNextGenHP ? 'flex-start' : 'flex-start')};
gap: ${props => (props.$isNextGenHP ? toRem(16) : toRem(16))};
position: relative;
flex-wrap: ${props => (props.$isNextGenHP ? 'wrap' : 'nowrap')};

/* NextGen inactive height */
height: ${props => (!props.$isNextGenHP ? toRem(24) : '')};
&.is-active {
  height: ${props => (!props.$isNextGenHP && !props.$showPointsAsCheckbox ? toRem(52) : '')};
  ${props => !props.$isNextGenHP && props.$showPointsAsCheckbox && 'height: auto; min-height: ' + toRem(52) + ';'}
}

/* NextGenHP: Establish positioning context for dropdown modals */
${props =>
  props.$isNextGenHP
    ? `
  @media (min-width: 992px) {
    position: relative;
  }
`
    : ''}

/* ============================================================
   FLEXBOX ORDER
   NextGen: Primary (1) → Secondary (2) → CTA (3) - all on same row
   NextGenHP: Primary (1) → CTA (2) on first row, Secondary (3) on second row
   ============================================================ */
.primary-wrapper {
  order: 1;
}
.document_search_form.standard {
  order: ${props => (props.$isNextGenHP ? '3' : '2')};
  ${props => props.$isNextGenHP && `width: 100%;`}
}
.searchfrom-submit-btn {
  order: ${props => (props.$isNextGenHP ? '2' : '3')};
  z-index: ${props => (props.$showPointsAsCheckbox ? '0' : '1')};
  ${props => props.$isNextGenHP && `flex: 1 1 0; min-width: 0;`}
  
  button {
    ${props => !props.$isNextGenHP && `padding: 0; margin-left: 0;`}
  }
}

/* ============================================================
   NEXTGEN INACTIVE STATE (tablet/desktop)
   - Compact display with 32px gaps
   - Clickable to activate
   ============================================================ */
&.is-inactive {
  gap: ${toRem(32)};
  
  .primary-wrapper,
  .document_search_form.standard {
    cursor: pointer;
    flex: 0 1 auto;
    min-width: 0;
  }
  
  /* 32px gap between destination and dates (now directly on primary-wrapper) */
  .primary-wrapper {
    gap: ${toRem(32)};
  }
  
  /* 32px gap between rooms and rates */
  .document_search_form.standard {
    gap: ${toRem(32)};
  }
  
  /* CTA flush right */
  .searchfrom-submit-btn {
    margin-left: auto;
  }
  
  /* Destination input truncation */
  ${props =>
    !props.$isNextGenHP &&
    `
    .primary-wrapper .search-field-input-container input[type=text].destination-input-field {
      max-width: ${toRem(640)};
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  `}
  
  /* Disable pointer events on inputs (form is clickable as a whole) */
  .m-input-text-field,
  input,
  button:not(.edit-cta-btn) {
    pointer-events: none;
  }
  
  .primary-wrapper *,
  .document_search_form.standard * {
    cursor: pointer;
  }
}

/* ============================================================
   NEXTGEN ACTIVE STATE (tablet/desktop)
   - All inputs equal width based on scenario
   - 16px gap between inputs
   - CTA flush right with margin-left: auto
   
   WITH showPointsAsCheckbox (Standard NextGen only):
   - Four fields stay as-is in row 1
   - Row 2: [UsePoints checkbox] [Gap/Space] [CTA buttons]
   
   Scenario 1 - Standard (4 inputs):
   [Destination 25%] [Dates 25%] | [Rooms 25%] [Rates 25%] | [CTA auto]
   
   Scenario 2 - hideDestination/ADF (3 inputs):
   [Dates 33%] | [Rooms 33%] [Rates 33%] | [CTA auto]
   
   Scenario 3 - hideDestination + Bulgari (2 inputs):
   [Dates 50%] | [Rooms 50%] | [CTA auto]
   ============================================================ */
&.is-active {
  gap: ${toRem(16)};
  
  /* Enable wrapping for Standard NextGen when checkbox mode is active */
  ${props => !props.$isNextGenHP && props.$showPointsAsCheckbox && `flex-wrap: wrap;`}
  
  /* ADF + Checkbox mode: High specificity selector to avoid !important */
  ${props =>
    !props.$isNextGenHP &&
    props.$showPointsAsCheckbox &&
    props.$hideDestination &&
    `
    /* ADF-specific layout: 3 equal fields + checkbox row below */
    /* High specificity: target this exact component instance */
    &&& {
      --adf-gap: ${toRem(16)};
      --adf-field-width: calc(33.333% - calc(var(--adf-gap) * 2 / 3));
      --adf-secondary-width: calc(66.667% - calc(var(--adf-gap) * 1 / 3));
      
      display: flex;
      flex-wrap: wrap;
      gap: var(--adf-gap);
      width: 100%;
      
      /* Primary wrapper: 1/3 width (dates only in ADF) */
      .primary-wrapper {
        flex: 0 0 var(--adf-field-width);
        width: var(--adf-field-width);
        max-width: var(--adf-field-width);
      }
      
      /* Secondary wrapper: 2/3 width (rooms + rates) */
      .document_search_form.standard {
        flex: 0 0 var(--adf-secondary-width);
        width: var(--adf-secondary-width);
        max-width: var(--adf-secondary-width);
        display: flex;
        gap: var(--adf-gap);
        
        /* Each field in secondary gets 50% of secondary width */
        > div.standard {
          flex: 0 0 calc(50% - calc(var(--adf-gap) / 2));
          width: calc(50% - calc(var(--adf-gap) / 2));
          max-width: calc(50% - calc(var(--adf-gap) / 2));
        }
      }
      
      /* Hide standalone CTA button from field row */
      > .searchfrom-submit-btn {
        display: none;
      }
      
      /* Checkbox row spans full width */
      .checkbox-cta-row {
        flex: 0 0 100%;
        width: 100%;
      }
    }
  `}
  
  
  /* PRIMARY WRAPPER (.primary-wrapper)
     Contains: destination + dates (or just dates if hideDestination)
     Now directly contains the .standard field wrappers (no intermediate div) */
  .primary-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: ${toRem(16)};
    min-width: 0;
    
    /* Flex sizing based on scenario */
    ${props => {
      if (props.$hideDestination) {
        if (props.$isBulgariDomain) {
          return 'flex: 1 1 0;';
        }
        // ADF+Checkbox layout handled by &&& block; plain ADF keeps original constraint
        if (!props.$showPointsAsCheckbox) {
          return `flex: 1 1 0; max-width: ${toRem(293)};`;
        }
        return 'flex: 1 1 0;';
      }
      return 'flex: 2 1 0;';
    }}
    
    /* Each input field wrapper (destination, dates) */
    > div.standard {
      flex: 1 1 0;
      min-width: 0;
      padding-left: 0;
      padding-right: 0;
    }
  }
  
  /* SECONDARY WRAPPER (.document_search_form.standard)
     Contains: rooms + rates (or just rooms if Bulgari) */
  .document_search_form.standard {
    display: flex;
    flex-wrap: nowrap;
    gap: ${toRem(16)};
    min-width: 0;
    
    /* Flex sizing based on scenario */
    ${props => {
      if (props.$hideDestination) {
        if (props.$isBulgariDomain) {
          return 'flex: 1 1 0;';
        }
        // For ADF: Secondary wrapper should be 2/3 of total width (66.67%)
        // to contain 2 fields of 33.33% each
        return 'flex: 2 1 0;';
      }
      return 'flex: 2 1 0;';
    }}
    
    /* Each input field wrapper */
    > div.standard {
      flex: 1 1 0;
      min-width: 0;
      padding-left: 0;
      padding-right: 0;
      ${props => {
        if (props.$hideDestination && !props.$isBulgariDomain) {
          // Preserve max-width for ADF without checkbox mode; the &&& block handles ADF+Checkbox
          if (props.$showPointsAsCheckbox) {
            return ''; // &&& block above handles exact sizing
          }
          return `max-width: ${toRem(293)};`; // original ADF constraint
        }
        return '';
      }}
    }
  }
  
  /* CHECKBOX + CTA ROW container (Standard NextGen Desktop with checkbox mode only) */
  ${props =>
    !props.$isNextGenHP &&
    props.$showPointsAsCheckbox &&
    `
    > .checkbox-cta-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      order: 3;
      padding-bottom: ${toRem(2)};
      
      .use-points-checkbox-wrapper {
        flex: 0 0 auto;
      }
      
      .searchfrom-submit-btn {
        flex: 0 0 auto;
        margin-left: auto;
      }
    }
  `}
  
  /* CTA BUTTON (.searchfrom-submit-btn)
     Auto width, flush right
     (When in checkbox mode, this is handled by parent .checkbox-cta-row) */
  .searchfrom-submit-btn {
    flex: 0 0 auto;
    ${props => !props.$showPointsAsCheckbox && 'margin-left: auto;'}
    
    /* CTA button group - right aligned with gap between buttons */
    .cta-button-group {
      justify-content: flex-end;
      margin-left: ${props => {
        if (props.$hideDestination) {
          return props.$isBulgariDomain ? toRem(8) : toRem(16); // Reduced for ADF
        }
        return props.$isBulgariDomain ? toRem(8) : toRem(36); // Keep original for standard
      }};
      
      /* Gap between Cancel and Submit buttons */
      .cancel-cta-btn {
        margin-right: ${toRem(24)};
      }
    }
  }
}

/* ============================================================
   NEXTGENHP DESKTOP FLEX LAYOUT (tablet and desktop only)
   
   Structure:
   - Row 1: .primary-wrapper (Destination + Dates) | .searchfrom-submit-btn (CTA)
     - All three elements equal width (33% each)
   - Row 2: .document_search_form.standard (Secondary) - hidden by default, full width
   
   Layout:
   [Destination 33%] [Dates 33%] [CTA 33%]
   [Secondary - full width, hidden by default]
   ============================================================ */
${props =>
  props.$isNextGenHP &&
  `
  @media ${baseVariables.mediaQuery.lg} {
    /* Primary wrapper contains destination and dates - takes 66% of row */
    .primary-wrapper {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-items: center;
      gap: ${toRem(16)};
      flex: 2 1 0;
      min-width: 0;
      
      /* Each input field (destination, dates) - equal width within primary */
      > div.standard {
        flex: 1 1 0;
        min-width: 0;
      }
    }
    
    /* CTA button - takes 33% of row */
    .searchfrom-submit-btn {
      flex: 1 1 0;
      min-width: 0;
      
      /* Make inner elements fill the container */
      > div {
        width: 100%;
      }
      
      /* Make the button fill the container */
      .m-button-primary-icon,
      .update-cta-hp {
        width: 100%;
      }
    }
    
    /* Secondary row - full width, hidden by default */
    .document_search_form.standard {
      width: 100%;
      display: flex;
      gap: ${toRem(32)};
    }
  }
`}
  
  .cn-searchfrom-submit-btn{
    top: ${toRem(14)};
    width: 28%;
  }
  .hotels-form-error-messages {
    max-width: fit-content;
    margin-left: 0;
    .message-link {
      text-decoration: underline;
    }
  }
  .search-field {
    border: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault} ${
  baseVariables.color.neutral40
};
    border-radius: ${baseVariables.border.borderInset02};
  }

  .m-input-text-field-no-border input[type='text']:is(${HINDI_LANG}){
    line-height: ${toRem(32)} !important;
  } 
    
  .primary-wrapper{
    transform: rotate(0);
    position: relative;
    z-index: 1;
  }
  .availibility-reward-points{
    @media ${baseVariables.mediaQuery.desktop}{
      position: absolute !important;
      left: 0;
      padding: 2rem;
      margin-top: 4rem;
    }
  }
  .cn-primary-wrapper{
      .col-lg-4{
        @media ${baseVariables.mediaQuery.tablet} {
          &:nth-child(2) {
            flex: 0 0 33%;
            max-width: 100%;
          }
          &:nth-child(3) {
            flex: 1 0 25%;
          }
        }
        @media ${baseVariables.mediaQuery.largeDesktop} {
        &:nth-child(2) {
          flex: 0 0 38%;
          max-width: 100%;
        }
      }
    }
  }
  .primary-tablet-container{
    height: unset;
    padding: unset;
  }
  .primary-container {
    border-top-right-radius: ${toRem(16)};
    border-top-left-radius: ${toRem(16)};
    margin-left: 0;
    margin-right: 0;
    /* NextGen: No padding, NextGenHP: Original padding */
    ${props =>
      !props.$isNextGenHP &&
      `
      padding-right: 0;
      padding-left: 0;
    `}
  }
  .dotted-divider {
    border-right: ${toRem(1)} dashed ${baseVariables.color.neutral30}};
  }
  .m-custom-select-block {
    display: flex;
  }
  .m-custom-select-block > label {
    line-height: ${toRem(18)};
  }
  .m-custom-select-block .icon-dropdown-down {
    margin-left: ${toRem(4)};
  }
  .search-form-secondary-wrapper {
    white-space: nowrap;
  }
  .adv-brand-filter {
    padding: 0 ${toRem(12)};

    .custom-scrollbar {
      ::-webkit-scrollbar {
        width: ${toRem(5)};
      }
      ::-webkit-scrollbar-track {
        background: ${baseVariables.color.base20};
        border-radius: ${toRem(2)};
        margin: ${toRem(12)} 0;
      }
      ::-webkit-scrollbar-thumb {
        background-color: ${baseVariables.color.neutral20};
        border-radius: ${toRem(2)};
      }
      ::-webkit-scrollbar-thumb:hover {
        background: ${baseVariables.color.neutral40};
      }
    }
  }
  .adv-search-brands-dropdown {
    max-width: ${toRem(348)};
    width: ${toRem(348)};
    height: ${toRem(460)};
    max-height: ${toRem(460)};
    min-height: ${toRem(460)};
    overflow-y: visible;
    border-radius: ${toRem(14)};
    .adv-search-brand-field-dropdown {
      position: static;
      height: ${toRem(460)};
      max-height: ${toRem(460)};
      min-height: ${toRem(460)};
      .m-dropdown-action-bar {
        background: ${baseVariables.color.base20};
        padding-bottom: ${toRem(16)};
        padding-right:${toRem(9)};
      }
      .brand-filter__category_label_btn {
        .btn-label-container {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        }
      }
    }
  }
`;
